export default [
  {
    _name: 'CSidebarNav',
    _children: [
      {
        _name: 'CSidebarNavItem',
        name: 'Dashboard',
        to: 'Dashboard',
        icon: {
          src: require('@/assets/img/element-4.png'),
          width: 15,
          height: 15,
          class: 'mr-3'
        },
      },
      {
        _name: 'CSidebarNavItem',
        name: 'Report Management',
        to: '/AskAI',
        icon: {
          src: require('@/assets/img/askai.png'),
          width: 15,
          height: 15,
          class: 'mr-3'
        },
        class: 'sidebar-item-text'
      },
      {
        _name: 'CSidebarNavItem',
        name: 'Incident Map',
        to: 'Recruitment',
        icon: {
          src: require('@/assets/img/profile-2user.png'),
          width: 15,
          height: 15,
          class: 'mr-3'
        },
      },
    
     
        {
        _name: 'CSidebarNavItem',
        name: 'Officers Management',
        to: 'ShortlistedCandidate',
        icon: {
          src: require('@/assets/img/user-tick.png'),
          width: 15,
          height: 15,
          class: 'mr-3'
        },
      },
      // {
      //   _name: 'CSidebarNavItem',
      //   name: 'All Candidates (Recruitment)',
      //   to: 'Recruitment',
      //   icon: {
      //     src: require('@/assets/img/profile-2user.png'),
      //     width: 15,
      //     height: 15,
      //     class: 'mr-3'
      //   },
      // },
      // {
      //   _name: 'CSidebarNavItem',
      //   name: 'Video List',
      //   to: 'VideoList',
      //   icon: {
      //     src: require('@/assets/img/video-square.png'),
      //     width: 15,
      //     height: 15,
      //     class: 'mr-3'
      //   },
      // },
     
      {
        _name: 'CSidebarNavDropdown',
        name: 'Input',
        icon: {
          src: require('@/assets/img/PlusThin.png'),
          width: 15,
          height: 15,
          class: 'mr-3'
        },
        items: [
          {
            name: 'Voucher',
            to: '/ManageVoucher',
            icon: {
              src: require('@/assets/img/iconvoucher.png'),
              width: 15,
              height: 15,
              class: 'mr-3'
            },
          },
          {
            name: 'Blog',
            to: '/ManageBlog',
            icon: {
              src: require('@/assets/img/iconblog.png'),
              width: 15,
              height: 15,
              class: 'mr-3'
            },
          },
          {
            name: 'Countries',
            to: '/ManageFlag',
            icon: {
              src: require('@/assets/img/quiz.png'),
              width: 15,
              height: 15,
              class: 'mr-3'
            },
          },
          {
            name: 'Contact Us',
            to: '/ManageContact',
            icon: {
              src: require('@/assets/img/iconcontact.png'),
              width: 15,
              height: 15,
              class: 'mr-3'
            },
          },
          {
            name: 'Question',
            to: '',
            icon: {
              src: require('@/assets/img/quiz.png'),
              width: 15,
              height: 15,
              class: 'mr-3'
            },
          },
          {
            name: 'Subscription',
            to: '/ManageSubscription',
            icon: {
              src: require('@/assets/img/subscribe.png'),
              width: 15,
              height: 15,
              class: 'mr-3'
            },
          },
          
          
          {
            name: 'Generate Report',
            to: '/GenerateReport',
            icon: {
              src: require('@/assets/img/document-upload.png'),
              width: 15,
              height: 15,
              class: 'mr-3'
            },
          },
          {
            name: 'Applicant',
            to: '/ManageApplicant',
            icon: {
              src: require('@/assets/img/Document.png'),
              width: 15,
              height: 15,
              class: 'mr-3'
            },
          },
          {
            name: 'Counter Visitor',
            to: '/CounterVisitor',
            icon: {
              src: require('@/assets/img/Document.png'),
              width: 15,
              height: 15,
              class: 'mr-3'
            },
          },
          // {
          //   name: 'Payment',
          //   to: '/Payment',
          // },
        
        ]
      },
      {
        _name: 'CSidebarNavDropdown',
        name: 'Share QR',
        icon: {
          src: require('@/assets/img/scan-barcode.png'),
          width: 15,
          height: 15,
          class: 'mr-3'
        },
        items: [
          {
            name: 'Customer Feedback',
            to: '/ManageQR',
            icon: {
              src: require('@/assets/img/Document.png'),
              width: 15,
              height: 15,
              class: 'mr-3'
            },
          },
          {
            name: 'Job Seeker',
            to: '/ManageQRJob',
            icon: {
              src: require('@/assets/img/Document.png'),
              width: 15,
              height: 15,
              class: 'mr-3'
            },
          },
          
         
        
        ]
      },
      {
        _name: 'CSidebarNavItem',
        name: 'Subscribe Users',
        to: '/ManageUser',
        icon: {
          src: require('@/assets/img/3User.png'),
          width: 15,
          height: 15,
          class: 'mr-3'
        },
      },
     
      {
        _name: 'CSidebarNavItem',
        name: 'Setting',
        to: 'Setting',
        icon: {
          src: require('@/assets/img/GearSix.png'),
          width: 15,
          height: 15,
          class: 'mr-3'
        },
      },
     
    ]
  },
  {
    _name: 'CSidebarNav',
    _children: [
      {
        _name: 'CSidebarNavItem',
        name: 'Setting',
        to: 'Setting',
      },
      {
        _name: 'CSidebarNavItem',
        name: 'Logout',
        to: 'Logout',
      },
    ],
    _style: 'margin-top: auto;', // Pushes the navigation items to the bottom of the sidebar
  }
]